import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { FidelityCardPointInfo, OfferCoupon } from '../../../../../../services/fidelity/fidelity';
import { ApiResponse } from '../../../../../../models/api-response.model';

/**
 * Service public de récupération d'un bon de réduction via l'API back-end.
 * N'étend pas BaseService car il n'a pas besoin de la session vendeur.
 * Réutilise l'endpoint FideliteCardInfoPoint existant et filtre côté client.
 */
@Injectable({ providedIn: 'root' })
export class VoucherService {
  private readonly http = inject(HttpClient);

  private get apiUrl(): string {
    return environment.configurators2d.baseApi + 'Fidelite/';
  }

  /**
   * Récupère un bon de réduction à partir de son code et de l'identifiant
   * KingFisher du client. Émet une erreur si le bon est introuvable.
   */
  getVoucherInfo(code: string, kfId: string): Observable<OfferCoupon> {
    const params = new HttpParams().set('idKingfisher', kfId);
    return this.http
      .get<ApiResponse<FidelityCardPointInfo>>(this.apiUrl + 'FideliteCardInfoPoint', { params })
      .pipe(
        map(response => {
          if (!response?.success || !response.data) {
            throw new Error(response?.error?.message ?? 'Impossible de récupérer les bons de réduction.');
          }
          const voucher = response.data.pointInfo?.discountsList?.offerCouponsList?.find(v => v.code === code);
          if (!voucher) {
            throw new Error('Bon de réduction introuvable.');
          }
          return voucher;
        })
      );
  }
}
